document.addEventListener('DOMContentLoaded', () => {
  const gmoCardForm = document.getElementById('gmo_modal_open_btn');

  if (!gmoCardForm) return;

  // カード情報とエラーメッセージのid
  const fieldConfigs = [
    { id: 'cardno', errorId: 'cardno-error', message: 'カード番号は必須です' },
    { id: 'expire_month', errorId: 'expire-error', message: '有効期限は必須です' },
    { id: 'expire_year', errorId: 'expire-error', message: '有効期限は必須です' },
    { id: 'holdername', errorId: 'holdername-error', message: 'カード名義人は必須です' },
    { id: 'securitycode', errorId: 'securitycode-error', message: 'セキュリティコードは必須です' }
  ];

  // フィールドとエラー要素のペアを取得する
  const fetchFieldAndErrorElements = (config) => {
    const fieldElement = document.getElementById(config.id);
    const errorElement = document.getElementById(config.errorId);
    return fieldElement && errorElement ? { fieldElement, errorElement, config } : null;
  };

  // バリデーションをクリアする関数（改善版）
  const clearGmoValidation = () => {
    fieldConfigs
      .map(fetchFieldAndErrorElements)
      .filter(elements => elements !== null)
      .forEach(({ fieldElement, errorElement }) => {
        fieldElement.value = '';
        fieldElement.setCustomValidity('');
        errorElement.classList.remove('show');
      });
  };

  // フィールド設定を初期化する関数
  const setupFieldValidation = (fieldConfig) => {
    const elements = fetchFieldAndErrorElements(fieldConfig);

    if (elements) {
      const { fieldElement, errorElement, config } = elements;

      // fieldConfigからメッセージを取得してspan要素に挿入
      errorElement.textContent = config.message;

      // HTML5バリデーションにも同じメッセージを設定
      fieldElement.setCustomValidity(config.message);

      fieldElement.addEventListener('input', () => {
        fieldElement.setCustomValidity('');
        errorElement.classList.remove('show');
      });
    }
  };

  // getTokenに渡されるコールバック関数
  const setCardToken = (response) => {
    if (response.resultCode != "000") {
      const errorMessages = {
        "100": "カード番号が入力されていません",
        "101": "カード番号に半角数字以外が入力されています",
        "102": "カード番号が10-16桁以外になっています",
        "110": "有効期限が入力されていません",
        "111": "有効期限に半角数字以外が入力されています",
        "112": "有効期限の年は4桁、月は2桁の半角数字で入力してください",
        "113": "有効期限の月に13以上が入力されています",
        "121": "セキュリティコードに数字以外が入力されています",
        "122": "セキュリティコードの桁数が間違っています",
        "131": "名義人に半角英数字、一部の記号以外が入力されています",
        "132": "名義人に51桁以上が入力されています"
      };
      window.alert(errorMessages[response.resultCode]);
    } else {
      document.getElementById("mp_token").value = response.tokenObject.token;
      document.getElementById("gmo_modal_open_btn").disabled = true;

      if (document.getElementById("card-info-block") != null) {
        document.getElementById("card-info-block").style.display = "none";
      }

      if (document.getElementById("add_card") != null) {
        document.getElementById("add_card").disabled = false;
      }
    }
  };

  // バリデーションとGMO処理を実行する関数
  const validateAndGetToken = () => {
    let isValid = true;

    fieldConfigs.forEach(input => {
      if (!document.getElementById(input.id).checkValidity()) {
        document.getElementById(input.errorId).classList.add('show');
        isValid = false;
      }
    });

    if (!isValid) {
      return; // バリデーションエラーの場合は処理を中断
    }

    // バリデーションが通った場合、モーダルを閉じる
    if (typeof window.closeGmoModal === 'function') {
      window.closeGmoModal();
    }

    // GMOの処理を実行
    const shopId = gmoCardForm.dataset.shopId;
    if (!shopId) {
      console.error('GMO Shop ID not found');
      return;
    }

    var card = {
      cardno : document.getElementById("cardno").value,
      expire : document.getElementById("expire_year").value + document.getElementById("expire_month").value,
      securitycode: document.getElementById("securitycode").value,
      holdername : document.getElementById("holdername").value
    };
    Multipayment.init(shopId);
    Multipayment.getToken(card, setCardToken);
  };

  // フィールドの初期化
  fieldConfigs
    .map(fetchFieldAndErrorElements)
    .filter(elements => elements !== null)
    .forEach(({ config }) => setupFieldValidation(config));

  // clearGmoValidation関数をグローバルに公開
  window.clearGmoValidation = clearGmoValidation;

  // validateAndGetToken関数をグローバルに公開
  window.validateAndGetToken = validateAndGetToken;
});
